import { ListItem, ListItemText, Theme, Typography } from '@mui/material'
import { HTMLAttributes } from 'react'
import { makeStyles } from 'tss-react/mui'
import { PartySearchResult } from '../../../services/APIs/InternalAPI/internal-api.contracts'
import { markTextWithSpacesComponent } from '../../../utils/textFilterUtils'

const useStyles = makeStyles()((theme: Theme) => ({
  resultRoot: {
    '& mark': {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.warning.contrastText,
    },
  },
}))

export function FindPartyResult(props: {
  baseElProps: HTMLAttributes<HTMLLIElement> & { key: string | number }
  option: PartySearchResult
  searchText: string
}) {
  const { classes } = useStyles()

  const { key, ...rest } = props.baseElProps

  return (
    <ListItem
      key={key}
      {...rest}
      style={{ ...props.baseElProps.style, padding: '1rem 1.5rem' }}
      sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
    >
      <ListItemText
        primary={props.option.names.map((name, index) => (
          <div className={classes.resultRoot} key={index}>
            <Typography variant="body1" fontWeight={600}>
              {markTextWithSpacesComponent(name, props.searchText)}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {markTextWithSpacesComponent(
                '[' + props.option.code + ']',
                props.searchText,
              )}
            </Typography>
          </div>
        ))}
        secondary={
          <span className={classes.resultRoot}>
            <Typography variant="caption" color="textSecondary">
              {markTextWithSpacesComponent(
                props.option.addresses[props.option.addresses.length - 1],
                props.searchText,
              )}
            </Typography>
          </span>
        }
      />
    </ListItem>
  )
}
